import { OlCourseCertificateType } from '@modules/types/graphql';

export const certificateTypeTranslates = {
    [OlCourseCertificateType.default]: 'common:blocks.course_certificate_type.default',
    [OlCourseCertificateType.class_8]: 'common:blocks.course_certificate_type.class_8',
    [OlCourseCertificateType.class_10]: 'common:blocks.course_certificate_type.class_10',
    [OlCourseCertificateType.dictation_2024]:
        'common:blocks.course_certificate_type.dictation_2024',
};

export const certificateTypeOptions = Object.entries(certificateTypeTranslates).map(
    ([type, value]) => ({
        key: type,
        value,
    }),
);
